var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 399.4 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "C_TEXT_primary",
    d: "M206.6 41.2c-.2 18 16 28 28.2 34 12.6 6.1 16.8 10 16.7 15.5-.1 8.4-10 12.1-19.3 12.2-16.2.3-25.6-4.4-33.1-7.9l-5.8 27.3c7.5 3.5 21.4 6.5 35.9 6.6 33.9 0 56.1-16.7 56.2-42.7.1-32.9-45.5-34.7-45.2-49.5.1-4.5 4.4-9.2 13.7-10.4 4.6-.6 17.4-1.1 31.8 5.6l5.7-26.4C283.5 2.7 273.5 0 261.1 0c-31.9 0-54.4 17-54.5 41.2M345.8 2.3c-6.2 0-11.4 3.6-13.7 9.2L283.6 127h33.9l6.7-18.6h41.4l3.9 18.6h29.9l-26-124.8h-27.6zm4.7 33.7l9.8 46.8h-26.8l17-46.8zm-185-33.7L138.8 127h32.3L197.8 2.3h-32.3zm-47.7 0L84.2 87.2 70.6 15C69 6.9 62.7 2.3 55.7 2.3H.8L0 5.9c11.3 2.4 24.1 6.4 31.8 10.6 4.7 2.6 6.1 4.8 7.7 11L65.2 127h34.1L151.6 2.3h-33.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.9f5811d40b6063633f9ac0243ff90ec7.svg";
export { ForwardRef as ReactComponent };